import { CustomTextField, CustomStack, SectionWrapper } from '@components/Styles/CommonStyle';

import { CustomButton } from '@components/Styles/ButtonStyle';
import React, { useState } from 'react';
import { Typography, TextField, TableBody, Box, Checkbox } from '@mui/material';
import UserListTable from '@components/common/Table/UserListTable';
import { theme } from '@components/Styles/theme';
import { useEffect } from 'react';
import {
  CustomTableContainer,
  CustomTable,
  CustomTableRow,
  CustomHeaderCell,
  CustomBodyCell,
} from '@components/Styles/TableStyle';
import { RequiredMark, RequiredMarkBox } from '@components/Styles/CommonStyle';
import { useDialog } from '@context/DialogContext';
import api from '@api/axios';

const UserList = () => {
  const { showDialog, hideDialog } = useDialog();
  const [userList, setUserList] = useState([]);
  const [checkedUserList, setCheckedUserList] = useState([]);
  // 리액트 예제 코드

  // 다이얼로그 예시를 보여주기 위한 버튼 핸들러들
  // const showAlertDialog = () => {
  //   showDialog({
  //     type: 'alert',
  //     title: '알림',
  //     message: '이것은 기본 알림 다이얼로그',
  //     onConfirm: () => console.log('알림 확인'),
  //   });
  // };

  // const showConfirmDialog = () => {
  //   showDialog({
  //     type: 'confirm',
  //     title: '확인',
  //     message: '정말 삭제하시겠습니까?',
  //     confirmText: '삭제',
  //     cancelText: '취소',
  //     onConfirm: () => console.log('삭제 확인'),
  //     onCancel: () => console.log('삭제 취소'),
  //   });
  // };

  // const showNestedDialog = () => {
  //   showDialog({
  //     type: 'nested',
  //     title: '약관 동의',
  //     message: () => (
  //       <Typography sx={{ mb: 2, textAlign: 'center' }}>서비스 이용을 위해 약관에 동의해주세요.</Typography>
  //     ),
  //     nested: {
  //       title: '서비스 이용약관',
  //       message: () => (
  //         <Box>
  //           <Typography component="p">1. 개인정보 수집 및 이용 동의</Typography>
  //           <Typography component="p">2. 서비스 이용약관 동의</Typography>
  //           <Typography component="p">3. 마케팅 정보 수신 동의</Typography>
  //         </Box>
  //       ),
  //       buttonText: '약관 자세히 보기',
  //       confirmText: '동의',
  //       cancelText: '거절',
  //       onConfirm: () => console.log('약관 동의'),
  //       onCancel: () => console.log('약관 거절'),
  //     },
  //   });
  // };

  // 체크박스 선택 및 미선택시(전체 선택)
  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedUserList(userList.map((item) => item.user_id));
    } else {
      setCheckedUserList([]); 
    }
  };

   // 체크박스 선택 및 미선택택(개별 선택)
  const handleCheckedUserList = (event, userId) => {
    const isChecked = event.target.checked;
    setCheckedUserList((prev) => {
      if (isChecked) {
        return [...prev, userId];
      } else {
        return prev.filter((id) => id !== userId);
      }
    });
  };

  // 사용자 목록 조회 
  const getUserList = () => {
    console.log('사용자 목록 조회');
    api.get('/api/auth/userlist').then((res) => {
      console.log('res');
      console.log(res);
      setUserList(res.data.users);
      
    });
  }

  // 비밀번호 유효성 검사
  const validateInput = (value) => {
    // 영문, 숫자, 특수문자 조합 + 4~15자
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=~`[\]{}|\\:;"'<>,.?/])[A-Za-z\d!@#$%^&*()_\-+=~`[\]{}|\\:;"'<>,.?/]{4,15}$/;
    return regex.test(value);
  };

  // 사용자 등록 및 수정
  const handleUserReg = (userInfoParam) => {
    const isUserInfoParam = userInfoParam.id ? true : false;
    showDialog({
      title: !isUserInfoParam ? '사용자 등록' : '사용자 수정',
      message: () => <UserRegModal userInfoParam={userInfoParam} />,
      type: 'confirm',
      onConfirm: () => {
        const userInfo = getUserInfo();

        console.log('handleUserReg :: userInfo');
        console.log(userInfo);

        if (userInfo.password !== userInfo.passwordCheck) {
          hideDialog();
          setTimeout(() => {
            showDialog({
              title: '사용자 등록',
              message: '비밀번호 확인이 일치하지 않습니다.',
              modalType: 'alert',
              onConfirm: () => {},
            });
          }, 500);
        } else if (!validateInput(userInfo.password)) {
          hideDialog();
          setTimeout(() => {
            showDialog({ title: '사용자 등록', message: '비밀번호 형식이 올바르지 않습니다.', modalType: 'alert' });
          }, 500);
        } else {
          const param = {
            name: userInfo.name,
            user_id: userInfo.user_id,
            password: userInfo.password,
            isAdmin: userInfo.isAdmin,
          };

          console.log('handleUserReg :: param');
          console.log(param);

          let url = '/api/auth/register';
          if (isUserInfoParam) url += '?id=' + userInfoParam.id;

          api
            .post(url, param)
            .then((res) => {
              console.log('res');
              console.log(res);

              if (res.status === 201) {
                getUserList();
                showDialog({ title: '사용자 등록', message: '사용자 등록이 완료되었습니다.', modalType: 'alert' });
              } else if (res.status === 200) {
                getUserList();
                showDialog({ title: '사용자 수정', message: '사용자 수정이 완료되었습니다.', modalType: 'alert' });
              }
            })
            .catch((err) => {
              console.log('err');
              console.log(err);

              showDialog({ title: '사용자 등록', message: '사용자 등록에 실패했습니다.', modalType: 'alert' });
            });
        }
      },
    });
  };

  // 관리자 권한 수정
  const handleIsAdminChange = (event, user) => {
    console.log('handleIsAdminChange :: event');
    console.log(event);
    console.log('handleIsAdminChange :: user');
    console.log(user);
    console.log('handleIsAdminChange :: user.is_admin');
    console.log(user.is_admin);

    const adminFlag = user.is_admin === 1 ? true : false;
    const newAdminFlag = !adminFlag;

    const param = {
      id: user.id,
      isAdmin: newAdminFlag,
    };

    console.log('handleIsAdminChange :: param');
    console.log(param);

    api
      .post('/api/auth/updateIsAdmin', param)
      .then((res) => {
        console.log('handleIsAdminChange :: res');
        console.log(res);

        if (res.status === 200) {
          getUserList();
          showDialog({ title: '사용자 수정', message: '관리자 권한 수정이 완료되었습니다.', modalType: 'alert' });
        }
      })
      .catch((err) => {
        console.log('handleIsAdminChange :: err');
        console.log(err);

        showDialog({ title: '사용자 수정', message: '관리자 권한 수정에 실패했습니다.', modalType: 'alert' });
      });
  };

  // 사용자 계정 해지
  const onDeleteUser = () => {
    api
      .post('/api/auth/deleteUser', {
        userList: checkedUserList,
      })
      .then((res) => {
        console.log('onDeleteUser :: res');
        console.log(res);

      if (res.status === 200) {
        getUserList();
        setCheckedUserList([]);
        showDialog({ title: '사용자 상태 수정', message: '계정이 비활성화 되었습니다.', modalType: 'alert' });
      }
    })
    .catch((err) => {
      console.log('onDeleteUser :: err');
      console.log(err);
    });
  };

  // 사용자 계정 활성화
  const onUseUser = () => {
    api
      .post('/api/auth/useUser', {
        userList: checkedUserList,
      })
      .then((res) => {
        console.log('onUseUser :: res');
        console.log(res);

      if (res.status === 200) {
        getUserList();
        setCheckedUserList([]);
        showDialog({ title: '사용자 상태 수정', message: '계정이 활성화 되었습니다.', modalType: 'alert' });
      }
    })
    .catch((err) => {
      console.log('onUseUser :: err');
      console.log(err);
    });
  };

  useEffect(() => {
    getUserList();
  }, []);

  // 사용자 정보 모달에서 추출을 위한 변수
  let latestUserInfo = null;
  const getUserInfo = () => latestUserInfo;

  const isCheckboxAllSelect = userList.length > 0 && userList.length === checkedUserList.length;

  // 사용자 등록 모달
  const UserRegModal = ({ userInfoParam }) => {
    console.log('UserRegModaluserInfoParam');
    console.log(userInfoParam);

    const isUserInfoParam = userInfoParam.id ? true : false;
    const [userInfo, setUserInfo] = useState({
      name: userInfoParam.name || '',
      user_id: userInfoParam.user_id || '',
      password: '',
      passwordCheck: '',
      isAdmin: userInfoParam.is_admin === 1 ? true : false,
    });

    console.log('UserRegModal :: userInfo');
    console.log(userInfo);

    // 사용자 정보 모달에서 추출
    latestUserInfo = userInfo;

    return (
      <CustomTableContainer>
        <CustomStack justifyContent="end" mb={1}>
          <RequiredMarkBox>
            <RequiredMark />
            (&nbsp;&nbsp;) 필수입력사항
          </RequiredMarkBox>
        </CustomStack>
        <CustomTable>
          <TableBody>
            <CustomTableRow>
              <CustomHeaderCell>
                {!isUserInfoParam ? <RequiredMark /> : ''}
                성명
              </CustomHeaderCell>
              <CustomBodyCell>
                <CustomTextField
                  placeholder="성명을 입력해주세요."
                  value={userInfo.name}
                  onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                  disabled={isUserInfoParam}
                />
              </CustomBodyCell>
            </CustomTableRow>
            <CustomTableRow>
              <CustomHeaderCell>
                {!isUserInfoParam ? <RequiredMark /> : ''}
                아이디
              </CustomHeaderCell>
              <CustomBodyCell>
                <CustomTextField
                  placeholder="아이디를 입력해주세요."
                  value={userInfo.user_id}
                  onChange={(e) => setUserInfo({ ...userInfo, user_id: e.target.value })}
                  disabled={isUserInfoParam}
                />
              </CustomBodyCell>
            </CustomTableRow>
            <CustomTableRow>
              <CustomHeaderCell>
                <RequiredMark />
                비밀번호
              </CustomHeaderCell>
              <CustomBodyCell>
                <CustomTextField
                  type="password"
                  placeholder="비밀번호 입력(영문,숫자,특수문자조합 4~15자 이내)"
                  value={userInfo.password}
                  onChange={(e) => setUserInfo({ ...userInfo, password: e.target.value })}
                />
              </CustomBodyCell>
            </CustomTableRow>
            <CustomTableRow>
              <CustomHeaderCell>
                <RequiredMark />
                비밀번호 확인
              </CustomHeaderCell>
              <CustomBodyCell>
                <CustomTextField
                  type="password"
                  placeholder="비밀번호 확인(비밀번호 재입력)"
                  value={userInfo.passwordCheck}
                  onChange={(e) => setUserInfo({ ...userInfo, passwordCheck: e.target.value })}
                />
              </CustomBodyCell>
            </CustomTableRow>
            {isUserInfoParam || (
              <CustomTableRow>
                <CustomHeaderCell>
                  <RequiredMark />
                  관리자 여부
                </CustomHeaderCell>
                <CustomBodyCell>
                  <Checkbox
                    size="small"
                    fullWidth
                    placeholder="비밀번호 확인(비밀번호 재입력)"
                    checked={userInfo.isAdmin}
                    onChange={(e) => setUserInfo({ ...userInfo, isAdmin: e.target.checked })}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    );
  };

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>사용자 리스트</Typography>
          <CustomStack>
            <CustomButton size="small" onClick={handleUserReg}>
              등록
            </CustomButton>
            <CustomButton size="small" onClick={onUseUser}>
              사용
            </CustomButton>
            <CustomButton size="small" color="error" onClick={onDeleteUser}>
              해지
            </CustomButton>
          </CustomStack>
        </CustomStack>
        <UserListTable
          userList={userList}
          checkedUserList={checkedUserList}
          setCheckedUserList={setCheckedUserList}
          handleUserReg={handleUserReg}
          handleIsAdminChange={handleIsAdminChange}
          isCheckboxAllSelect={isCheckboxAllSelect}
          handleCheckAll={handleCheckAll}
          handleCheckedUserList={handleCheckedUserList}
        />
      </SectionWrapper>

      {/* 임시 다이얼로그 예시 버튼들 */}
      {/* 
      <CustomStack direction="row" spacing={2} mt={4}>
        <CustomButton variant="contained" onClick={showAlertDialog}>
          알림 다이얼로그
        </CustomButton>
        <CustomButton variant="contained" onClick={showConfirmDialog}>
          확인 다이얼로그
        </CustomButton>
        <CustomButton variant="contained" onClick={showNestedDialog}>
          중첩 다이얼로그
        </CustomButton>
      </CustomStack> 
      */}
    </React.Fragment>
  );
};

export default UserList;
